import React from 'react';
import { useController } from 'react-hook-form';

import { Field, FieldError } from '@/Components/shadcn/field';
import { Textarea } from '@/Components/shadcn/textarea';
import { cn } from '@/lib/utils';

export interface CriteriaTextAreaInputProps {
    name?: string;
    disabled?: boolean;
}

const CriteriaTextAreaInput = ({ name = '', disabled }: CriteriaTextAreaInputProps) => {
    const { field, fieldState } = useController({ name });
    const { error } = fieldState;

    return (
        <Field data-invalid={error ? true : undefined}>
            <Textarea
                name={field.name}
                value={field.value ?? ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                ref={field.ref}
                rows={4}
                disabled={disabled}
                aria-invalid={error ? true : undefined}
                className={cn(
                    'resize-none',
                    'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:border-destructive aria-[invalid=true]:focus-visible:ring-destructive dark:aria-[invalid=true]:focus-visible:border-destructive/50 dark:aria-[invalid=true]:focus-visible:ring-destructive/50',
                )}
            />
            <FieldError>{error?.message ?? null}</FieldError>
        </Field>
    );
};

export default CriteriaTextAreaInput;
